/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssignContractorToProjectCommand } from '../models';
// @ts-ignore
import { ContractorDetailsDto } from '../models';
// @ts-ignore
import { ContractorDtoPaginatedList } from '../models';
// @ts-ignore
import { ContractorProjectDetailsDto } from '../models';
// @ts-ignore
import { CreateContractorCommand } from '../models';
// @ts-ignore
import { UpdateContractorCommand } from '../models';
/**
 * ContractorsApi - axios parameter creator
 * @export
 */
export const ContractorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, isActive?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsIdDelete', 'id', id)
            const localVarPath = `/api/Contractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsIdGet', 'id', id)
            const localVarPath = `/api/Contractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdProjectsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsIdProjectsGet', 'id', id)
            const localVarPath = `/api/Contractors/{id}/projects`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignContractorToProjectCommand} [assignContractorToProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdProjectsPost: async (id: number, assignContractorToProjectCommand?: AssignContractorToProjectCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsIdProjectsPost', 'id', id)
            const localVarPath = `/api/Contractors/{id}/projects`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignContractorToProjectCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContractorCommand} [updateContractorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdPut: async (id: number, updateContractorCommand?: UpdateContractorCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsIdPut', 'id', id)
            const localVarPath = `/api/Contractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContractorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateContractorCommand} [createContractorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsPost: async (createContractorCommand?: CreateContractorCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContractorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorsApi - functional programming interface
 * @export
 */
export const ContractorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, isActive?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsGet(pageNumber, pageSize, searchTerm, projectId, isActive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsIdProjectsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorProjectDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsIdProjectsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignContractorToProjectCommand} [assignContractorToProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsIdProjectsPost(id: number, assignContractorToProjectCommand?: AssignContractorToProjectCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsIdProjectsPost(id, assignContractorToProjectCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContractorCommand} [updateContractorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsIdPut(id: number, updateContractorCommand?: UpdateContractorCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsIdPut(id, updateContractorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateContractorCommand} [createContractorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsPost(createContractorCommand?: CreateContractorCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsPost(createContractorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractorsApi - factory interface
 * @export
 */
export const ContractorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsGet(pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, isActive?: boolean, options?: any): AxiosPromise<ContractorDtoPaginatedList> {
            return localVarFp.apiContractorsGet(pageNumber, pageSize, searchTerm, projectId, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdGet(id: number, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdProjectsGet(id: number, options?: any): AxiosPromise<Array<ContractorProjectDetailsDto>> {
            return localVarFp.apiContractorsIdProjectsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AssignContractorToProjectCommand} [assignContractorToProjectCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdProjectsPost(id: number, assignContractorToProjectCommand?: AssignContractorToProjectCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorsIdProjectsPost(id, assignContractorToProjectCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateContractorCommand} [updateContractorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsIdPut(id: number, updateContractorCommand?: UpdateContractorCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorsIdPut(id, updateContractorCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateContractorCommand} [createContractorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsPost(createContractorCommand?: CreateContractorCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiContractorsPost(createContractorCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiContractorsGet operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsGetRequest
 */
export interface ContractorsApiApiContractorsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ContractorsApiApiContractorsGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {boolean}
     * @memberof ContractorsApiApiContractorsGet
     */
    readonly isActive?: boolean
}

/**
 * Request parameters for apiContractorsIdDelete operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsIdDeleteRequest
 */
export interface ContractorsApiApiContractorsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiContractorsIdGet operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsIdGetRequest
 */
export interface ContractorsApiApiContractorsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiContractorsIdProjectsGet operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsIdProjectsGetRequest
 */
export interface ContractorsApiApiContractorsIdProjectsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsIdProjectsGet
     */
    readonly id: number
}

/**
 * Request parameters for apiContractorsIdProjectsPost operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsIdProjectsPostRequest
 */
export interface ContractorsApiApiContractorsIdProjectsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsIdProjectsPost
     */
    readonly id: number

    /**
     * 
     * @type {AssignContractorToProjectCommand}
     * @memberof ContractorsApiApiContractorsIdProjectsPost
     */
    readonly assignContractorToProjectCommand?: AssignContractorToProjectCommand
}

/**
 * Request parameters for apiContractorsIdPut operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsIdPutRequest
 */
export interface ContractorsApiApiContractorsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorsApiApiContractorsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateContractorCommand}
     * @memberof ContractorsApiApiContractorsIdPut
     */
    readonly updateContractorCommand?: UpdateContractorCommand
}

/**
 * Request parameters for apiContractorsPost operation in ContractorsApi.
 * @export
 * @interface ContractorsApiApiContractorsPostRequest
 */
export interface ContractorsApiApiContractorsPostRequest {
    /**
     * 
     * @type {CreateContractorCommand}
     * @memberof ContractorsApiApiContractorsPost
     */
    readonly createContractorCommand?: CreateContractorCommand
}

/**
 * ContractorsApi - object-oriented interface
 * @export
 * @class ContractorsApi
 * @extends {BaseAPI}
 */
export class ContractorsApi extends BaseAPI {
    /**
     * 
     * @param {ContractorsApiApiContractorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsGet(requestParameters: ContractorsApiApiContractorsGetRequest = {}, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.projectId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorsApiApiContractorsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsIdDelete(requestParameters: ContractorsApiApiContractorsIdDeleteRequest, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorsApiApiContractorsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsIdGet(requestParameters: ContractorsApiApiContractorsIdGetRequest, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorsApiApiContractorsIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsIdProjectsGet(requestParameters: ContractorsApiApiContractorsIdProjectsGetRequest, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsIdProjectsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorsApiApiContractorsIdProjectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsIdProjectsPost(requestParameters: ContractorsApiApiContractorsIdProjectsPostRequest, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsIdProjectsPost(requestParameters.id, requestParameters.assignContractorToProjectCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorsApiApiContractorsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsIdPut(requestParameters: ContractorsApiApiContractorsIdPutRequest, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsIdPut(requestParameters.id, requestParameters.updateContractorCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorsApiApiContractorsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorsApi
     */
    public apiContractorsPost(requestParameters: ContractorsApiApiContractorsPostRequest = {}, options?: AxiosRequestConfig) {
        return ContractorsApiFp(this.configuration).apiContractorsPost(requestParameters.createContractorCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
